import { Routes } from '@angular/router';
import { AutomationAnywhereComponent } from './automation-anywhere/automation-anywhere.component';
import { CanActivateViaAuthGuard } from 'app/bz-authentication/bz-can-activate-auth';
import { BluePrismComponent } from './blue-prism/blue-prism.component';
import { UipathComponent } from './uipath/uipath.component';
import {menus} from '../core/models/constants';

export const RoutesRPA: Routes = [
  {
      path: menus.AutomationAnywhere.path,
      data: { title : menus.AutomationAnywhere.title },
      component : AutomationAnywhereComponent,
      canActivate: [CanActivateViaAuthGuard]
  },
  {
      path: menus.BluePrism.path,
      data: { title: menus.BluePrism.title },
      component: BluePrismComponent,
      canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.UiPath.path,
    data: { title: menus.UiPath.title },
    component: UipathComponent,
    canActivate: [CanActivateViaAuthGuard]
  }
];
